import { request } from './client';
import type { AiAskResponse, AiRoleRow, AiUsageReport } from '@kassa/shared';

// AI icazəsi (rol üzrə ai.ask) və sahibin AI xərc hesabatı (KT-68).
export const aiApi = {
  aiRoles: () => request<AiRoleRow[]>('GET', '/api/settings/ai-roles'),
  setAiRole: (roleId: string, enabled: boolean) =>
    request<{ roleId: string; enabled: boolean }>('PUT', `/api/settings/roles/${encodeURIComponent(roleId)}/ai`, { enabled }),
  // Köməkçiyə sual (KT-100)
  aiAsk: (question: string, conversationId: string | null) =>
    request<AiAskResponse>('POST', '/api/ai/ask', conversationId ? { question, conversationId } : { question }),
  aiUsage: (month?: string) => request<AiUsageReport>('GET', `/api/ai/usage${month ? `?month=${encodeURIComponent(month)}` : ''}`),
};
